<template xmlns="http://www.w3.org/1999/html">
  <div style="position: relative; height: 40px;">
    <span class="date">
    {{ getDate() }}
  </span>
    <span class="editBtn" v-if="smsStatus === 1" @click="handleEdit">修改短信内容</span>
  </div>

  <div class="item">


    {{content}}
    <div class="icon" :class="getIconClass()"/>
  </div>

</template>

<script>
import dayjs from "dayjs";
export default {
  name: "SmsSendRecordItem",
  props: {
    id: String,
    smsStatus: Number,
    date: String,
    content: String,
  },
  methods:{
    getDate(){
      return dayjs(this.date).format("YYYY/MM/DD HH:mm")
    },
    getIconClass(){
      switch(this.smsStatus) {
        case 0:
          return 'icon-arrived'
        case 1:
          return 'icon-not-send'
        case 2:
          return 'icon-failed'
        case 3:
          return 'icon-cancelled'
        default:
          return 'icon-arrived'
      }
    },
    handleEdit() {
      this.$emit('editSms', this.id, this.content);
    }
  }

}
</script>

<style scoped>
.date{
  margin-top: 8px;
  height: 40px;
  font-size: 12px;
  line-height: 40px;
  color: #9ca3af;
}

.editBtn {
  position: absolute;
  right: 0;
  top: 8px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #00D477;
  cursor: pointer;
  padding: 0 5px;
  border-radius: 4px;
  background-color: transparent;
  border: 1px solid #00D477;
}
.item{
  padding: 10px;
  background-color: white;
  border-radius: 10px;
  font-size: 12px;
  color: #292833;
  box-sizing: border-box;
  word-wrap:break-word;
  overflow: hidden;

  position: relative;
  word-break: break-all;
  width: 345px;
  min-height: 100px;
}
.icon{
  width: 64px;
  height: 64px;
  right: 10px;
  position: absolute;
  z-index: 2;
  top:25%;
  background-size: 64px 64px;
  background-repeat: no-repeat;
}

.icon-arrived {
  background-image: url('../../assets/image/arrived.png');
}

.icon-not-send {
  background-image: url('../../assets/image/not-send.png');
}

.icon-failed {
  background-image: url('../../assets/image/failed.png');
}

.icon-cancelled {
  background-image: url('../../assets/image/cancelled.png');
}
</style>